import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import cn from 'classnames'

import { Box, Typography } from '@material-ui/core'

import { COLUMN_CONFIG } from './table-helpers'
import MessageTable from './MessageTable'

import './index.scss'

const MessageSection = ({ messages, sectionType, onChange, className }) => {
  const TABLE_CONFIG = {
    'On-Follow': {
      tableLabel: 'Follow Event Trigger',
      tableConfig: {
        omitColumns: [COLUMN_CONFIG.scheduledDateColumn],
      },
    },
    'Marked-Applying': {
      tableLabel: 'Applying Event Trigger',
      tableConfig: {
        omitColumns: [COLUMN_CONFIG.scheduledDateColumn],
      },
    },
    'Marked-Applied': {
      tableLabel: 'Applied Event Trigger',
      tableConfig: {
        omitColumns: [COLUMN_CONFIG.scheduledDateColumn],
      },
    },
    'One-Time': {
      tableConfig: {
        omitColumns: [COLUMN_CONFIG.priorityColumn],
        columnDefs: {
          [COLUMN_CONFIG.segmentColumn]: {
            headerText: 'Audience',
          },
          [COLUMN_CONFIG.scheduledDateColumn]: {
            headerText: 'Send Date',
          },
        },
      },
    },
  }
  const config = get(TABLE_CONFIG, sectionType)
  const tableConfig = get(config, 'tableConfig', {})
  const label = get(config, 'tableLabel')
  return (
    <div className={cn('message-section-comp', className)}>
      {label && (
        <Box pt={2.5}>
          <Typography
            variant="h6"
            color="textPrimary"
          >
            {label}
          </Typography>
        </Box>
      )}
      <MessageTable
        className="message-table"
        messages={messages}
        onChange={onChange}
        config={tableConfig}
      />
    </div>
  )
}
MessageSection.propTypes = {
  className: PropTypes.string,
  messages: PropTypes.array.isRequired,
  sectionType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default MessageSection
